import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { BaseDiner } from 'src/app/models';
import {
  ClearSearchDinersResult,
  GetDiners
} from 'src/app/store/diners/diners.action';
import { DinersSelectors } from 'src/app/store/diners/diners.selectors';

@Component({
  selector: 'pos-bill-to-room-payment',
  templateUrl: './bill-to-room.modal.html',
  styleUrls: ['./bill-to-room.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BillToRoomPaymentModal {
  @Select(DinersSelectors.getFilteredResidents)
  readonly diners$: Observable<BaseDiner[]>;

  constructor(private modalController: ModalController, private store: Store) {}

  onAssignDiner(diner: BaseDiner) {
    this.store.dispatch(new ClearSearchDinersResult());
    this.modalController.dismiss(diner);
  }

  onCloseModal() {
    this.store.dispatch(new ClearSearchDinersResult());
    this.modalController.dismiss();
  }

  searchingDiners(event: any) {
    const query = event.detail.value || [];
    //this is cheat to prevent the ionChange call two times
    if (event.defaultPrevented || query.length <= 2) {
      return;
    }

    event.preventDefault();
    this.store.dispatch(
      new GetDiners({
        name: query,
        patients_only: true
      })
    );
  }
}
